"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSsrPopupBanners = void 0;
const enums_1 = require("@finbackoffice/enums");
const withSsrPopupBanners = async (client, locale, device, appName, scopes = [], isLoggedIn) => {
    let tags = [device, appName];
    if (scopes.length) {
        tags = [...tags, ...scopes];
    }
    else {
        tags = [...tags, enums_1.PopupTags.Allpages];
    }
    let response;
    if (isLoggedIn) {
        response = await client.getLoggedInPopups({
            language: locale,
            tags,
        });
    }
    else {
        response = await client.getPublicPopups({
            language: locale,
            tags,
        });
    }
    return response.items.filter((item) => item.tags.includes(appName));
};
exports.withSsrPopupBanners = withSsrPopupBanners;
//# sourceMappingURL=popup.banners.js.map